import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthRoute, DashboardRoute } from './RouterHelpers';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from 'lodash';
import { motion } from 'framer-motion';
import { pageTransition, pageVariants } from 'config/helpers/animation_helper';
// import { generate_notification } from 'redux/actions/AppActions'
import { useDispatch, useSelector } from 'react-redux';
import { unixDate } from 'config/helpers/date_helper';
import {
  ABOUT,
  MYPROFILE,
  STAFF,
  HOME,
  CREDENTIALS,
  USER,
  DOCUMENTS,
  CONFIG,
} from 'config/helpers/router_helper';
import { getPathNames } from 'config/helpers/router_helper';
import { APP_NAME } from 'config/common-consts';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from 'component/MainUIFrame/MainFrame';
import { ACTION_CLOSE_MAIN_DRAWER } from 'component/MainUIFrame/constants';
import { Backdrop } from '@mui/material';

const LOGIN_PAGE = React.lazy(() => import('screens/login/login'));
const ERROR_PAGE = React.lazy(() => import('component/404/NotFound'));
const RESET_PASSWORD = React.lazy(() => import('screens/login/reset'));

const RootRouter = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  // const theme = useSelector(state => state?.currentUser?.theme);
  const isAdmin = useSelector(state => state?.currentUser?.isAdmin);
  const isLoggedInAsAdmin = useSelector(
    state => state?.currentUser?.isLoggedInAsAdmin
  );
  const MODULES = isAdmin && isLoggedInAsAdmin ? adminModules : employeeModules;

  useEffect(() => {
    const unsubscribe = toast.onChange(messages => {
      // dispatch(
      // 	generate_notification({
      // 		message: messages?.content,
      // 		isRead: false,
      // 		addedOn: unixDate(new Date()),
      // 		id: messages?.id,
      // 	})
      // )
    });

    return () => {
      unsubscribe();
    };
  }, [dispatch]);

  useEffect(() => {
    let paths = getPathNames();
    let path = paths[paths.length - 1] || '';
    // document.title = `${APP_NAME} | ${_.capitalize(path.replaceAll('_', ' '))}`;
    document.title = `${APP_NAME}`;
  }, [location]);

  const hasChildObject = obj => {
    let child = [];
    Object.keys(obj).map(m => {
      if (typeof obj[m] === 'object' && !obj[m].hasOwnProperty('$$typeof')) {
        Object.keys(obj[m]).map(p => {
          child.push({ component: obj[m][p], parent: m, name: p });
          return true;
        });
      }
      return true;
    });
    return child;
  };

  const AnimationExtendedComponent = props => {
    let Module = props.jsx;
    let ModuleWrapper = props.wrapper;
    let ChildModuleWrapper = props.childwrapper;
    return (
      <>
        <ModuleWrapper />
        <motion.div
          key={props.componentKey}
          initial="initial"
          animate="in"
          variants={pageVariants}
          transition={pageTransition}
        >
          {(ChildModuleWrapper && <ChildModuleWrapper />) || null}
          <Module />
        </motion.div>
      </>
    );
  };

  const EmptyWrapper = () => {
    return <></>;
  };

  const getParentWrapper = (mod, page = false) => {
    if (page === false) {
      if (
        COMMON_WRAPPERS[mod] &&
        COMMON_WRAPPERS[mod].hasOwnProperty('WRAPPER')
      ) {
        return COMMON_WRAPPERS[mod].WRAPPER;
      } else return EmptyWrapper;
    } else {
      if (
        COMMON_WRAPPERS[mod] &&
        COMMON_WRAPPERS[mod][page] &&
        COMMON_WRAPPERS[mod][page].hasOwnProperty('WRAPPER')
      ) {
        return COMMON_WRAPPERS[mod][page].WRAPPER;
      } else return EmptyWrapper;
    }
  };

  const makePath = (mod, page, sub = false) => {
    let path = '';
    path += _.lowerCase(mod).replaceAll(' ', '_') + '/';

    if (page === 'EDIT') {
      path += ':id';
      return path;
    }

    path += _.lowerCase(page).replaceAll(' ', '_') + '/';
    if (sub) {
      path += _.lowerCase(sub).replaceAll(' ', '_');
    }
    return path;
  };

  const TopLabelWrapper = ({ children }) => {
    const { mainDrawerOpen } = useMainFrameState();
    const isMobileResolution = window?.innerWidth <= 768;
    const isLoginPage =
      location?.pathname === '/login' || location?.pathname === '/reset';
    const dispatch = useMainFrameDispatch();
    return (
      <>
        {isLoginPage ? (
          children
        ) : (
          <div
            className="p-3"
            style={{
              height: 'calc(100vh - 45px)',
              overflow: 'auto',
              backgroundColor:
                localStorage.getItem('screenMode') !== 'dark'
                  ? 'white'
                  : '#2c353d',
              // backgroundColor: theme === 'light' ? 'white' : '#2c353d',
            }}
          >
            <Backdrop
              open={mainDrawerOpen}
              onClick={() => {
                dispatch({ type: ACTION_CLOSE_MAIN_DRAWER });
              }}
              style={{
                zIndex: 1,
                backdropFilter: 'blur(3px)',
                backgroundColor: 'transparent',
              }}
            />
            <div
              className="p-3 ps-4"
              style={{
                // backgroundColor: theme === 'light' ? '#f1f0f3ba' : '#454e57',
                backgroundColor:
                  localStorage.getItem('screenMode') !== 'dark'
                    ? '#f1f0f3ba'
                    : '#454e57',
                // borderRadius: '15px',
                minHeight: '100%',
              }}
            >
              {children}
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <TopLabelWrapper key={MODULES?.length}>
        <ToastContainer
          newestOnTop
          toastClassName={() =>
            localStorage.getItem('screenMode') == 'dark'
              ? 'toast-background-dark'
              : 'toast-background-light'
          }
        />
        <Routes key={MODULES?.length}>
          {/* {/ auth routes /} */}
          {Object.keys(MODULES).map((mod, idx) => {
            return (
              <React.Fragment key={`${mod}_${idx}`}>
                {Object.keys(MODULES[mod]).map((page, pId) => {
                  let childModules = hasChildObject(MODULES[mod][page]);
                  let ParentWrapper = getParentWrapper(mod);
                  return (
                    <>
                      {childModules.length === 0 ? (
                        <>
                          {Object.keys(MODULES[mod][page]).map((sub, subId) => {
                            let ChildWrapper = getParentWrapper(mod, page);
                            return (
                              <>
                                {hasChildObject(MODULES[mod][page][sub])
                                  .length !== 0 ? (
                                  <Route
                                    key={`${page}_${idx}_${pId}_${subId}`}
                                    path={makePath(mod, page, sub)}
                                    index
                                    element={
                                      <DashboardRoute
                                        component={
                                          <AnimationExtendedComponent
                                            componentKey={`${mod}/${page}`}
                                            jsx={MODULES[mod][page][sub]}
                                            wrapper={ParentWrapper}
                                            childwrapper={ChildWrapper}
                                          />
                                        }
                                      />
                                    }
                                  />
                                ) : (
                                  <></>
                                )}
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <></>
                      )}
                      <Route
                        key={`${page}_${idx}_${pId}`}
                        path={makePath(mod, page)}
                        index
                        element={
                          <DashboardRoute
                            component={
                              <AnimationExtendedComponent
                                componentKey={`${mod}/${page}`}
                                jsx={MODULES[mod][page]}
                                wrapper={ParentWrapper}
                              />
                            }
                          />
                        }
                      />
                    </>
                  );
                })}
              </React.Fragment>
            );
          })}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/login"
            index
            element={<AuthRoute component={LOGIN_PAGE} />}
          />
          <Route
            path="/reset"
            index
            element={<AuthRoute component={RESET_PASSWORD} />}
          />
          {/* <Route
					path="/reset"
					element={<AuthRoute component={RESET_PASSWORD} />}
				/> */}
          {/* <Route path="*" element={<ERROR_PAGE />} /> */}
          <Route
            path="*"
            element={<DashboardRoute component={<ERROR_PAGE />} />}
          />
        </Routes>
      </TopLabelWrapper>
    </>
  );
};

const COMMON_WRAPPERS = {
  // [HOME]: {
  //     WRAPPER: React.lazy(() => import('screens/appointments/AppointmentsTabWrapper')),
  //     SOME: {
  //         WRAPPER: React.lazy(() => import('screens/appointments/AppointmentsTabWrapperSub')),
  //     }
  // },
};

const adminModules = {
  [HOME]: {
    DASHBOARD: React.lazy(() => import('screens/Dashboard/AdminDashboard')),
  },
  [CREDENTIALS]: {
    CREDENTIALSALERTS: React.lazy(() =>
      import('screens/CredentialsManagement/credentialsManagement')
    ),
    APPROVECREDENTIALS: React.lazy(() =>
      import('screens/CredentialsManagement/credentialsManagement')
    ),
  },
  [CONFIG]: {
    CREDENTIALS: React.lazy(() => import('screens/Config/Config')),
    DEPARTMENTSANDROLES: React.lazy(() => import('screens/Config/Config')),
  },
  [STAFF]: {
    MANAGE: React.lazy(() => import('screens/StaffManagement/staffManagement')),
    ADDANEWSTAFFMEMBER: React.lazy(() =>
      import('screens/StaffManagement/StaffDetails/StaffDetails')
    ),
    EDIT: React.lazy(() =>
      import('screens/StaffManagement/StaffDetails/StaffDetails')
    ),
  },
  // [DOCUMENTS]: {
  //   UPLOAD: React.lazy(() => import('screens/DocumentAI/documentView')),
  // },
  [ABOUT]: {
    US: React.lazy(() => import('screens/AboutUs')),
  },
  [MYPROFILE]: {
    PROFILE: React.lazy(() => import('screens/MyProfile')),
  },
};

const employeeModules = {
  [HOME]: {
    DASHBOARD: React.lazy(() => import('screens/UserDashboard/UserDashboard')),
  },
  [USER]: {
    CREDENTIALSSTATUS: React.lazy(() =>
      import('screens/UserCredentials/UserCredentials')
    ),
  },
  // [STAFF]: {
  //   MANAGE: React.lazy(() => import('screens/StaffManagement/staffManagement')),
  // },
  // [DOCUMENTS]: {
  //   UPLOAD: React.lazy(() => import('screens/DocumentAI/documentView')),
  // },
  [ABOUT]: {
    US: React.lazy(() => import('screens/AboutUs')),
  },
  [MYPROFILE]: {
    PROFILE: React.lazy(() => import('screens/MyProfile')),
  },
};

// const MODULES = true ? adminModules : employeeModules;
export default RootRouter;
